export default "__VITE_ASSET__qSYO_IXt__"